import React from 'react';
import styles from './DisplayTabContent.module.scss';
import { SegmentedControl, T } from '@colonist/ui';
import clsx from 'clsx';
export const DisplayTabContent = ({ isAnimationsEnabled, onAnimationsChange, isAntialiasEnabled, onAntialiasChange, resolution, onResolutionChange, powerPreference, onPowerPreferenceChange })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.displayTabContentContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.displaySetting
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.displayTab.animation.title'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.segmentedControlInlineWrapper
    }, /*#__PURE__*/ React.createElement(SegmentedControl, {
        options: [
            {
                id: 'false',
                label: {
                    key: 'strings:game.settings.displayTab.animation.options.Off'
                }
            },
            {
                id: 'true',
                label: {
                    key: 'strings:game.settings.displayTab.animation.options.On'
                }
            }
        ],
        activeId: isAnimationsEnabled ? 'true' : 'false',
        onTabChange: (id)=>onAnimationsChange(id == 'true'),
        size: "lg"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.displaySetting
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.displayTab.edgeSmoothing.title'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.segmentedControlInlineWrapper
    }, /*#__PURE__*/ React.createElement(SegmentedControl, {
        options: [
            {
                id: 'false',
                label: {
                    key: 'strings:game.settings.displayTab.edgeSmoothing.options.Off'
                }
            },
            {
                id: 'true',
                label: {
                    key: 'strings:game.settings.displayTab.edgeSmoothing.options.On'
                }
            }
        ],
        activeId: String(isAntialiasEnabled),
        onTabChange: (id)=>onAntialiasChange(id == 'true'),
        size: "lg"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.displaySetting, styles.linebreak)
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.displayTab.graphics.title'
        }
    })), /*#__PURE__*/ React.createElement(SegmentedControl, {
        fullWidth: true,
        options: [
            {
                id: 0.5,
                label: {
                    key: 'strings:game.settings.displayTab.graphics.options.Low'
                }
            },
            {
                id: 1,
                label: {
                    key: 'strings:game.settings.displayTab.graphics.options.Medium'
                }
            },
            {
                id: 1.5,
                label: {
                    key: 'strings:game.settings.displayTab.graphics.options.High'
                }
            },
            {
                id: 2,
                label: {
                    key: 'strings:game.settings.displayTab.graphics.options.Ultra'
                }
            }
        ],
        activeId: resolution,
        onTabChange: (id)=>onResolutionChange(id),
        size: "lg"
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.displaySetting, styles.linebreak)
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.displayTab.performance.title'
        }
    })), /*#__PURE__*/ React.createElement(SegmentedControl, {
        fullWidth: true,
        options: [
            {
                id: 'low-power',
                label: {
                    key: 'strings:game.settings.displayTab.performance.options.Low'
                }
            },
            {
                id: 'default',
                label: {
                    key: 'strings:game.settings.displayTab.performance.options.Medium'
                }
            },
            {
                id: 'high-performance',
                label: {
                    key: 'strings:game.settings.displayTab.performance.options.High'
                }
            }
        ],
        activeId: powerPreference,
        onTabChange: (id)=>onPowerPreferenceChange(id),
        size: "lg"
    })));
};
